import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { autobind } from 'core-decorators';
import { noop } from '@src/utils/common-util';
import { isFunction } from '@src/utils/type-utils';
import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
export default class extends BaseStore {
  #name = 'DownloadSectionStore';

  onCopyrightVisibleChange = noop;

  constructor(props = {}) {
    super();

    if (isFunction(props.onCopyrightVisibleChange)) {
      this.onCopyrightVisibleChange = props.onCopyrightVisibleChange;
    }
    Object.assign(this, props);
  }

  @observable
  downloadList = [
    {
      title: '下载步骤一',
      description: require('./images/description-1.png'),
      image: require('./images/step-1.png'),
      isButton: false
    },
    {
      title: '下载步骤二',
      description: require('./images/description-2.png'),
      image: require('./images/step-2.png'),
      isButton: true
    },
    {
      title: '下载步骤三',
      description: require('./images/description-3.png'),
      image: require('./images/step-3.png'),
      isButton: false
    },
    {
      title: '下载步骤四',
      description: require('./images/description-4.png'),
      image: require('./images/step-4.png'),
      isButton: false
    }
  ];

  followList = [
    {
      title: '微信公众号',
      image: require('./images/code-gzh.png'),
      type: 'gzh'
    },
    {
      title: '官方抖音',
      image: require('./images/code-dy.png'),
      type: 'dy',
      link: 'https://v.douyin.com/xr8y3iqGI_M/'
    },
    {
      title: '企业微信',
      image: require('./images/code-kfgj.png'),
      type: 'kf'
    },
    {
      title: '游戏微博',
      image: require('./images/code-wb.png'),
      type: 'wb',
      link: 'https://weibo.com/u/7478851023'
    }
  ];

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      // 淡入淡出效果
      effect: 'fade',
      observer: true,
      watchSlidesProgress: true
    },
    onSlideChange: realIndex => {
      this.activeIndex = realIndex;
    }
  });
  goNext = () => {
    this.baseSwiperStore.goNext();
  };
  goPrev = () => {
    this.baseSwiperStore.goPrev();
  };

  @observable activeIndex = 0;

  @autobind
  showCopyright() {
    this.onCopyrightVisibleChange(true);
  }

  onLinkClick = (type, link) => {
    if (type === 'dy' || type === 'wb') {
      window.open(link, '_blank');
    }
  };

  use() {
    super.use();
    useMount(() => {});
  }
}
